import React, { useEffect, useState, useContext } from 'react'
import Button from '../formfields/Button'
import { GlobalContext } from '../GlobalContext'
import HeaderDetails from '../shared-components/HeaderDetails'
import Card from '../ui-elements/Card'
import Spinner from '../ui-elements/Spinner'
import ChecklistSummary from './ChecklistSummary'
import SummaryCheckWindow from './SummaryCheckWindow'
import { json } from 'stream/consumers'
import NoActiveCheckPeriods from './NoActiveCheckPeriods'
import NoChecklists from './NoChecklists'
import Paginate from '../ui-elements/Paginate'
import FilterChecklistCategories from './FilterChecklistCategories'
import { useSearchParams } from 'react-router-dom'


type Props = {

}

function AllChecklists({
}: Props) {

  const {
    tableData,
    currentOrganisation,
    t
  } = useContext(GlobalContext)

  const [searchParams] = useSearchParams()
  const [displayItems, setDisplayItems] = useState<ObjectStringKeyAnyValue>({})


  const [checklistIdsToDisplay, setChecklistIdsToDisplay] = useState<string[]>([])
  const arrayStartIndex = displayItems.indexOfFirstItem || 0
  const arrayEndIndex = displayItems.indexOfLastItem || 5
  const arrayToDisplay: any[] = checklistIdsToDisplay && checklistIdsToDisplay.slice(arrayStartIndex, arrayEndIndex)


  useEffect(() => {
    filterChecklistCategories()
    redirectToLocallyStoredParams()
  }, [searchParams, tableData])

  const redirectToLocallyStoredParams = () => {
    console.log()
    const locallyStoredParams = localStorage.getItem(`checklistCategoryFilters-${currentOrganisation}`)
    const paramsFromUrl = searchParams.getAll('filter')
    // console.log('Params from URL:', paramsFromUrl)
    // console.log('Locally stored params:', locallyStoredParams)
    if (locallyStoredParams && paramsFromUrl.length === 0) {
      const params = JSON.parse(locallyStoredParams)
      //console.log('Locally stored params found', params)
      if (params && params.length > 0) {
        //console.log('Redirecting to locally stored params', params)
        const newSearchParams = new URLSearchParams()
        params.forEach((param: string) => {
          newSearchParams.append('filter', param)
        })
        window.location.search = newSearchParams.toString()
      }
    }
  }


  const filterChecklistCategories = () => {
    if (tableData && tableData.Checklists) {
      let filters = searchParams.getAll('filter')

      const checklistIdsSortedByChecklistName = tableData && tableData.Checklists && Object.keys(tableData.Checklists)
      checklistIdsSortedByChecklistName && checklistIdsSortedByChecklistName.sort((a: any, b: any) => {
        const checklistA = tableData.Checklists[a]
        const checklistB = tableData.Checklists[b]
        if (checklistA && checklistB && checklistA.ChecklistName && checklistB.ChecklistName) {
          return checklistA.ChecklistName.localeCompare(checklistB.ChecklistName)
        }
        return 0
      })

      const visibleChecklistIds = checklistIdsSortedByChecklistName.filter((checklistId: string) => {
        const checklist = tableData.Checklists[checklistId]
        return checklist && checklist.isActive !== false && checklist.isDeleted !== 'Y'
      })

      if (filters.length > 0) {
        const newChecklistIdsToDisplay: string[] = []
        visibleChecklistIds.forEach((checklistId: string) => {
          const thisChecklist = tableData.Checklists[checklistId]
          const checklistCategories = thisChecklist['ChecklistCategories'] || []
          // check if any of the checklistCategories match any of the filters
          let anyMatches = false
          filters.forEach((filter) => {
            if (checklistCategories.includes(filter)) {
              anyMatches = true
            }
          })
          if (anyMatches) {
            newChecklistIdsToDisplay.push(checklistId)
          }
        })
        setChecklistIdsToDisplay(newChecklistIdsToDisplay)
      } else {
        setChecklistIdsToDisplay(visibleChecklistIds)
      }
    } else {
      //console.log('tabledata is empty')
    }
  }


  return <div className={`w-full flex-1 h-full flex flex-col items-center gap-2`}>

    <HeaderDetails
      titleText={t("Dashboard.AllChecklists.heading")}
    />



    <div className={`max-w-3xl w-full px-5 py-5 flex flex-col gap-4`}>

      <FilterChecklistCategories redirectBaseUrl={'/checklists/'} />

      {tableData && tableData.Checklists && tableData.ChecklistPeriods ?
        <div className={`flex flex-col gap-4`}>
          {checklistIdsToDisplay.length > 0 ?
            <div className={`flex flex-row flex-wrap gap-2 text-xs`}>

              <Paginate
                setDisplayItems={setDisplayItems}
                itemsPerPage={10}
                arrayToPageThrough={checklistIdsToDisplay}
              >
                {arrayToDisplay.map((checklistId, index) => {
                  const thisChecklist = tableData.Checklists[checklistId] || null
                  return <ChecklistSummary
                    key={index}
                    checklistId={checklistId}
                    thisChecklist={thisChecklist}
                  />
                })}
              </Paginate>
            </div>
            :
            <NoChecklists />
          }
        </div>
        :
        <Spinner><p>{t('General.loading')}</p></Spinner>}


    </div>
  </div>
}
export default AllChecklists